'use strict';

import React from 'react'
import ReactDOM from 'react-dom'
import { TrainingSessionForm } from '../react-components/training-session-form.jsx'
import { TrainingSession } from '../models/training-sessions.js'
import { Race } from '../models/races.js'
import { saveTrainingSessions } from '../persistence/training-sessions-and-races.js'

var keep_open_training_session_form;

class TrainingSessionFormContainer extends React.Component {

  state = {
    currently_saving: false,
    changes_need_saving: false,
    training_session: new TrainingSession({}),
    race: new Race({}),
    form_errors: []
  }

  updateTrainingSession = (training_session, needs_saving) => {
    this.setState({training_session: training_session});
    if (needs_saving) {
      this.setState({changes_need_saving: true});
    }
  }

  sessionDataChanged = () => {
    if (this.state.changes_need_saving === false) {
      this.setState({changes_need_saving: true});
    }
  }

  savingStarted = () => {
    this.setState({currently_saving: true, changes_need_saving: false})
  }

  closePersistentSidebar = () => {

    xhale.helper.deleteCookie('keep-open-training-session');
    keep_open_training_session_form.setState({training_session: null});

    // Close up the space reserved for the sidebar.
    $('#main-content .main-content-inner').css({right: '0px'});
  }

  training_session_saved = (response, status) => {
    if ('training_sessions' in response) {
      if (!('errors' in response)) {
        // If there were no errors, update the session with the saved details.
        var training_session = new TrainingSession(response.training_sessions[0]);
        this.setState({form_errors: [], currently_saving: false, session: training_session})
      }
      else {
        this.setState({form_errors: response.errors, currently_saving: false});
      }
    }
  }

  render() {

    if (this.state.training_session == null) {
      return null;
    }
    var form = (
      <TrainingSessionForm
        training_session={this.state.training_session}
        race={this.state.race}
        perspective="coach"
        mode="training_session"
        csrf_token={this.props.csrf_token}
        mobile_mode={false}
        columns={1}
        form_errors={this.state.form_errors}
        display_more_details_link={false}
        athlete_data={typeof(athlete_data) == 'undefined' ? null : athlete_data}
        savingStarted={this.savingStarted}
        sessionDataChanged={this.sessionDataChanged}
        currently_saving={this.state.currently_saving}
        changes_need_saving={this.state.changes_need_saving}
        updateTrainingSession={this.updateTrainingSession}
        saveTrainingSessions={saveTrainingSessions}
        form_saved_callback={this.training_session_saved}
        prefix='keep-open'
      />
    );

    return (
      <div id="training-session-container" style={{right: 0, position: 'absolute', top: '91px', background: 'white', width: '365px', bottom: 0, overflow: 'auto'}}>
        <div onClick={this.closePersistentSidebar} style={{cursor: 'pointer', textDecoration: 'underline'}}>click to close session</div>
        {form}
      </div>
    )
  }
}

const activate_persistent_sidebar = function () {

  // Activate this if a cookie exists 'keep-open-training-session' and they
  // are looking at someone they coach.
  var keep_open_training_session_id = xhale.helper.getCookie('keep-open-training-session');
  if (keep_open_training_session_id) {

    // Create space for the sidebar.
    $('#main-content .main-content-inner').css({right: '365px'});

    // Fetch the training session data.
    $.getJSON('/coach/ajax-training-session/' + keep_open_training_session_id + '/').done(function (data) {

      // If the form isn't displayed yet, display it.
      if ($('#keep-open-training-session').length == 0) {

        // Build the training session form.
        $('#main-content').append('<div id="keep-open-training-session"></div>');
        var keep_open_container = $('#keep-open-training-session');
        keep_open_training_session_form = ReactDOM.render(<TrainingSessionFormContainer />, $(keep_open_container)[0]);

      }

      // Update the form.
      var training_session = new TrainingSession(data.training_session);
      keep_open_training_session_form.setState({training_session: training_session});

    });

  }
  else if (typeof(keep_open_training_session_form) != 'undefined') {
    keep_open_training_session_form.closePersistentSidebar();
  }
}

export default activate_persistent_sidebar;
